angular.module("app").directive("artContent", [
  "$timeout",
  "$window",
  "artDashboardRepository",
  (timeout, window, artDashboardRepository) => {
    let link = (scope, element) => {
      scope.data = [];
      scope.showCollection = false;
      scope.showImageDetails = false;
      scope.saveImageDetails = false;
      scope.imageDetailsData = null;
      window.scr = scope;
      scope.collectionDataList = [];

      scope.itemHeight = () => {
        const elements = element.find(".logo-item");
        if (!elements.length || elements[0].clientWidth <= 0) {
          return;
        }
        return (scope.elemHeight =
          elements[0].clientWidth && elements[0].clientWidth + "px");
      };

      scope.itemHeight();

      $(window).resize(() => {
        const elements = element.find(".logo-item");
        if (!elements.length || elements[0].clientWidth <= 0) {
          return;
        }
        timeout(() => {
          return (scope.elemHeight = elements[0].clientWidth + "px");
        }, 10);
      });

      scope.toggleImageDetails = () => {
        scope.showImageDetails = !scope.showImageDetails;
      };

      scope.$on("mood_state", (data) => {
        scope.saveImageDetailsData = data.targetScope.data;
        scope.toggleImageDetails();
        scope.toggleSaveImageDetails();
      });

      scope.toggleSaveImageDetails = () => {
        scope.saveImageDetails = scope.saveImageDetails ? false : true;
      };

      scope.$on("mood_state_changed", () => {
        scope.toggleSaveImageDetails();
      });

      scope.imageClickHandler = (artwork, index) => {
        artDashboardRepository
          .getArtWorkDetails(
            artwork.id
          )
          .then(function (data) {
            scope.imagedata = data.art;
            scope.index = index;
            scope.toggleImageDetails();
          });
      };

      scope.isModeColor = () => {
        return scope.viewMode === "color";
      };

      scope.isModeArtist = () => {
        return scope.viewMode === "artist";
      };

      scope.isModePeriod = () => {
        return scope.viewMode === "period";
      };

      scope.isModeSchool = () => {
        return scope.viewMode === "school";
      };
    };

    return {
      restrict: "E",
      templateUrl: "app/directives/dbArtContent/dbArtContentView.html",
      link: link,
      scope: {
        originalData: "=data",
        artworkData: "=",
        selectedItem: "=",
        viewMode: "=",
      },
    };
  },
]);
